module.exports = __webpack_public_path__ + "static/media/angela-lose.32e14f1f.jpg";